export const environment = {
  production: false,
  api: 'https://sidac-dev.quality.com.br/api',
  auth: 'https://sidac-dev.quality.com.br/api/auth',
  cep: 'https://sidac-dev.quality.com.br/cep',
  secretKey: '5bNV9N8iS8s4qDsEClVAtjjt67Hfhr9k',
  versionPkg: require('../../package.json').version,
  chaveTrocaSenha: 'yfg'
};
